import { connect } from 'react-redux';

import { viewOrganizerProfile } from '../redux/organizers/actions';
import { followOrganizer } from '../redux/organizerArticle/actions';
import {
    clickOn5TFFollowOrganizer,
    navigateOnFiveToFollow,
    limitReachedOnFiveToFollow,
} from '../redux/events/actions';
import OrganizerArticleBucket from '../components/OrganizerArticleBucket';

const _mapStateToProps = (state) => ({
    isLoading: state.app.loadingState && state.app.loadingState.isSearchLoading,
    isMobile: state.app.isMobile,
});

const _mapDispatchToProps = {
    onFollowOrganizer: followOrganizer,
    handleViewOrganizer: viewOrganizerProfile,
    trackGAEvent: clickOn5TFFollowOrganizer,
    trackScrollEvent: navigateOnFiveToFollow,
    trackLimitReached: limitReachedOnFiveToFollow,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(OrganizerArticleBucket);
